<template>
    <div
        class="map-tab-nbr mg-scrollbar"
        :class="{
            'show-collapse': showCollapse,
            'show-business': !isMobile,
            collapsed: collapsed
        }"
        @click="replace && $emit('update:replace', false)"
        @mouseenter="replace && $emit('update:replace', false)"
    >
        <div class="tab-collapse">
            <i
                class="iconfont"
                v-for="tab in tabs"
                :key="tab.type"
                :class="[
                    { active: activeType === tab.type },
                    iconMap[tab.type]
                ]"
                @click="tabClick(tab.type)"
            ></i>
        </div>
        <div class="tab-header" v-show="!showDetail">
            <span
                v-for="tab in tabs"
                :key="tab.type"
                class="item"
                :class="[{ active: activeType === tab.type }, tab.type]"
            >{{ tab.label }}</span
            >
        </div>
        <div class="tab-body" v-show="!showDetail">
            <div
                v-for="tab in tabs"
                :key="tab.type"
                class="tab-content"
                :class="[{ 'more-panel': !!tab.moreLink }, tab.type]"
                v-show="activeType === tab.type"
            >
                <template v-if="tab.type === 'house'">
                    <ul v-if="tab.data" class="list">
                        <li
                            v-for="item in tab.data.slice(0, houseLimit)"
                            :key="item.id"
                            class="item"
                            :class="{
                                active:
                                    itemActiveKey ===
                                    'house-' +
                                    item.latitude +
                                    '-' +
                                    item.longitude
                            }"
                            @mouseenter="!isMobile && itemEnter('house', item)"
                            @mouseleave="itemLeave('house')"
                            @click="isMobile && itemEnter('house', item)"
                        >
                            <a
                                :href="transformLink2WordPress(item.detailLink)"
                                :target="getDetailTarget(item)"
                                rel="noopener noreferrer"
                            >
                                <p class="addr">
                                    {{ item.formatAddress }}
                                </p>
                                <p class="desc">
                                    <span class="prop">{{
                                        item.propertyTypeText ||
                                            item.propertyType
                                    }}</span>
                                    <span
                                        v-if="item.commercialRealEstate"
                                        class="detail"
                                    >
                                        <span
                                        >{{
                                            $t('md-map.sqft', {
                                                num:
                                                    item.sqft > -1
                                                        ? item.sqft
                                                        : '-'
                                            })
                                        }}
                                            |</span
                                        >
                                        <span
                                        >{{ item.lotSizeWithUnit }} |</span
                                        >
                                        <span>{{ item.pricePerSqft }}</span>
                                    </span>
                                    <span v-else class="detail">
                                        <span
                                            class="vertical-line"
                                            v-if="item.bedrooms > 0"
                                        >{{
                                            formatBed(item.bedrooms, 2)
                                        }}</span
                                        >
                                        <span
                                            class="vertical-line"
                                            v-if="item.bathrooms > 0"
                                        >{{
                                            formatBath(item.bathrooms, 2)
                                        }}</span
                                        >
                                        <span class="vertical-line">{{
                                            formatSqft(item, 2)
                                        }}</span>
                                    </span>
                                </p>
                                <div class="house-mls-info">
                                    <div class="mls-info">
                                        <p
                                            v-if="
                                                item.mlsOrg.mlsOrgHas74 &&
                                                    item.mlsListingId
                                            "
                                        >
                                            MLS# {{ item.mlsListingId }}
                                        </p>
                                        <div v-if="item.provided" v-html="item.provided"></div>
                                    </div>
                                    <div
                                        v-if="item.mlsLogo"
                                        class="house-mls-info-logo"
                                    >
                                        <site-img
                                            :src="item.mlsLogo"
                                            dir="height"
                                        ></site-img>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <div v-if="tab.moreLink && !wordPressSSR" class="more">
                        <a :href="tab.moreLink" rel="noopener noreferrer">{{
                            tab.moreLabel || $t('md-map.more')
                        }}</a>
                    </div>
                </template>
                <template v-else-if="tab.type === 'school'">
                    <template
                        v-for="(group, index) in tab.groups"
                        :key="group.label"
                    >
                        <div
                            class="group"
                            :class="{
                                active: schoolGroupActiveIndex === index
                            }"
                            @click="schoolGroupClick(index, group)"
                        >
                            {{ group.label }}
                            {{ group.data && group.data.length }}
                            <i class="iconfont icon-arrow-down"></i>
                        </div>
                        <ul class="list">
                            <li
                                v-for="item in group.data"
                                :key="item.id + '-' + (item.level || '')"
                                class="item server-property"
                                :class="{
                                    active:
                                        itemActiveKey ===
                                        'school-' +
                                        item.latitude +
                                        '-' +
                                        item.longitude
                                }"
                                @mouseenter="
                                    !isMobile && itemEnter('school', item)
                                "
                                @mouseleave="itemLeave('school')"
                                @click="schoolItemClick(item)"
                            >
                                <div
                                    class="score"
                                    :class="[
                                        'score-' + item.gsRating,
                                        {
                                            high: item.gsRating > 9,
                                            middle:
                                                item.gsRating >= 6 &&
                                                item.gsRating <= 9,
                                            low:
                                                !item.gsRating ||
                                                item.gsRating < 6
                                        }
                                    ]"
                                >
                                    {{ item.gsRating || 0 }}
                                </div>
                                <p class="school-name">{{ item.name }}</p>
                                <p class="school-desc">
                                    {{ item.admission }} | {{ item.gradeLow }} -
                                    {{ item.gradeHigh }}
                                </p>
                            </li>
                        </ul>
                    </template>
                </template>
                <template v-else-if="tab.type === 'business'">
                    <template v-for="(group, index) in tab.groups" :key="index">
                        <div
                            class="group"
                            :class="{
                                active: businessGroupActiveIndex === index
                            }"
                            @click="businessGroupClick(index, group)"
                        >
                            {{ group.label }}
                            {{ group.data && group.data.length }}
                            <i class="iconfont icon-arrow-down"></i>
                        </div>
                        <ul class="list">
                            <li
                                v-for="item in group.data"
                                :key="item.id"
                                class="item"
                                :class="{
                                    active:
                                        itemActiveKey ===
                                        'business-' +
                                        item.latitude +
                                        '-' +
                                        item.longitude
                                }"
                                @mouseenter="
                                    !isMobile && itemEnter('business', item)
                                "
                                @mouseleave="itemLeave('business')"
                                @click="isMobile && itemEnter('business', item)"
                            >
                                <p class="name">{{ item.name }}</p>
                                <p class="detail">
                                    <span>{{
                                        item.categoryTertiary ||
                                            item.categorySecondary ||
                                            $t('md-map.others')
                                    }}</span>
                                    <span
                                        v-if="
                                            item.categoryTertiary ||
                                                item.categorySecondary
                                        "
                                        class="line"
                                    >|</span
                                    >
                                    <span>{{ $t('md-map.phone') }}</span>
                                    <a
                                        v-if="item.phone"
                                        class="tel"
                                        :href="'tel:' + item.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >{{ $ft.formatPhone(item.phone) }}</a
                                    >
                                </p>
                            </li>
                        </ul>
                    </template>
                </template>
            </div>
        </div>
        <div class="detail-header" v-show="showDetail">
            <span class="to-back" @click="detailBack">
                <i class="iconfont icon-prev"></i
                >{{ $t('md-map.return') }}</span
            >
        </div>
        <div ref="detailBody" class="detail-body" v-show="showDetail">
            <div class="school" :class="{ 'more-panel': detailData.moreLink }">
                <p class="name">{{ detailData.name }}</p>
                <ul class="table">
                    <li
                        v-for="item in detailData.table"
                        :key="item.label"
                        class="item"
                    >
                        <p class="label">{{ item.label }}</p>
                        <a
                            v-if="item.label === 'Phone'"
                            class="value"
                            :href="'tel:' + item.value"
                            target="_top"
                            rel="noopener noreferrer"
                        >{{ $ft.formatPhone(item.value) }}</a
                        >
                        <p
                            v-else-if="item.label === 'Expenditure'"
                            class="value"
                        >
                            {{ $ft.formatCurrency({ value:item.value, noSpace:true, currencySymbol}) }}
                        </p>
                        <p v-else class="value">{{ item.value }}</p>
                    </li>
                </ul>
                <div v-if="detailData.moreLink && !wordPressSSR" class="more">
                    <a :href="detailData.moreLink" rel="noopener noreferrer">{{
                        detailData.moreLabel ||
                            $t('md-map.viewHomesInThisSchool')
                    }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mapTab from '../map-tab';

export default {
    emits: ['showNormalMarker'],
    mixins: [mapTab],
    data: function() {
        return {
            collapsed: true,
            iconMap: {
                school: 'icon-school3',
                house: 'icon-house-fill',
                business: 'icon-show'
            }
        };
    },
    watch: {
        selectTab(value) {
            if (value) {
                let flag = false;
                for (let i = 0, len = this.tabs.length; i < len; i++) {
                    if (value === this.tabs[i].type) {
                        flag = true;
                        break;
                    }
                }
                if (flag) {
                    this.activeType = value;
                    this.collapsed = false;
                    this.$emit('showNormalMarker', false);
                } else {
                    this.activeType = '';
                    this.collapsed = true;
                    this.$emit('showNormalMarker', true);
                }
            } else {
                this.activeType = '';
                this.collapsed = true;
                this.$emit('showNormalMarker', true);
            }
        }
    },
    methods: {
        tabClick(type) {
            if (type === this.activeType) {
                this.activeType = '';
                this.collapsed = true;
                this.$emit('showNormalMarker', true);
            } else {
                this.activeType = type;
                this.collapsed = false;
                this.$emit('showNormalMarker', false);
            }
        },
        updateDetailData(item) {
            const table = [
                {
                    label: this.$t('md-map.admission'),
                    value: item.admission
                },
                {
                    label: this.$t('md-map.level'),
                    value: `${item.gradeLow}-${item.gradeHigh}`
                }
            ];
            table.push({
                label: this.$t('md-map.address'),
                value: this.$t('md-map.addressStreetCity', {
                    street: item.addressStreet,
                    city: item.addressCity,
                    state: item.addressState,
                    zip: item.addressZip
                })
            });
            if (item.gsRating) {
                table.push({
                    label: this.$t('md-map.rating'),
                    value: item.gsRating
                });
            }
            if (item.phone) {
                table.push({
                    label: this.$t('md-map.phone0'),
                    value: item.phone
                });
            }
            table.push({
                label: this.$t('md-map.library'),
                value: item.library
                    ? this.$t('md-map.yes')
                    : this.$t('md-map.no')
            });
            if (item.expenditure) {
                table.push({
                    label: this.$t('md-map.expenditure'),
                    value: item.expenditure
                });
            }
            if (item.studentTeacherRatio) {
                table.push({
                    label: this.$t('md-map.ratio'),
                    value: this.$t('md-map.studentTeacherRatio', {
                        ratio: item.studentTeacherRatio
                    })
                });
            }
            return {
                name: item.name,
                table
            };
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-map.classic {
    &.nbr {
        .icon-full-screen,
        .gm-fullscreen-control {
            right: 50px !important;
        }
    }
    .map-tab-nbr {
        flex-shrink: 0;
        height: 100%;
        min-width: 380px;
        width: 0;
        position: absolute;
        right: 0;
        background-color: #fff;
        transition: min-width 0.3s ease;
        .tab-collapse {
            position: absolute;
            right: 100%;
            width: 40px;
            top: 0;
            background-color: #fff;
            border: 1px solid #e6e6e6;
            border-top: none;
            border-radius: 2px;
            .iconfont {
                font-size: 20px;
                color: #8ba0b6;
                line-height: 59px;
                display: block;
                text-align: center;
                cursor: pointer;
                &.active {
                    @include color-theme();
                }
                &:before {
                    display: block;
                }
                &.icon-show:before {
                    font-size: 18px;
                }
            }
        }
        .tab-header {
            height: 60px;
            line-height: 60px;
            background: #fff;
            font-size: 22px;
            font-family: var(--font-bold);
            display: flex;
            border-bottom: 1px solid #e6e6e6;
            .item {
                position: relative;
                color: #282828;
                padding: 0 30px;
                display: none;
                &.active {
                    display: block;
                }
                &.business {
                    display: none;
                }
            }
        }
        .tab-body {
            position: absolute;
            top: 60px;
            bottom: 0;
            width: 100%;
            .tab-content {
                width: 100%;
                height: 100%;
                overflow: auto;
                .group {
                    line-height: 50px;
                    font-size: 16px;
                    color: #505050;
                    padding-left: 30px;
                    padding-right: 30px;
                    position: relative;
                    cursor: pointer;
                    &:before {
                        content: '';
                        position: absolute;
                        top: 49px;
                        left: 30px;
                        right: 30px;
                        height: 0;
                        border-bottom: 1px solid #e6e6e6;
                    }
                    .icon-arrow-down {
                        position: absolute;
                        right: 30px;
                        &:before {
                            display: block;
                            font-size: 12px;
                            font-weight: bold;
                            transform: scale(0.7);
                        }
                    }
                    + .list {
                        display: none;
                    }
                    &.active {
                        .icon-arrow-down {
                            &:before {
                                transform: rotate(180deg) scale(0.7);
                            }
                        }
                        + .list {
                            display: block;
                        }
                        &:before {
                            border-bottom: none;
                        }
                    }
                }
                .item {
                    position: relative;
                    margin: 4px 0;
                    &:first-child {
                        margin-top: 0;
                        &:before {
                            display: none;
                        }
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                    &:hover,
                    &.hover,
                    &.active {
                        background-color: #f4f6fb;
                        &:before,
                        + .item:before {
                            display: none;
                        }
                    }
                }
                &.house {
                    .item {
                        height: auto;
                        padding: 15px 10px 0 30px;
                        cursor: pointer;
                        font-size: 16px;
                        .addr {
                            color: #424242;
                            font-family: var(--font-medium);
                            @include ellipsis();
                            text-decoration: underline;
                        }
                        .desc {
                            margin-top: 5px;
                            color: #282828;
                            display: flex;
                            font-size: 14px;
                            white-space: nowrap;

                            .prop {
                                @include ellipsis();
                                font-size: 13px;
                                color: #fff;
                                border-radius: 2px;
                                margin-right: 12px;
                                padding: 0 4px;
                                display: inline-block;
                                background-color: #c0c7d7;
                            }
                            .vertical-line {
                                &:after {
                                    content: ' |';
                                }
                                &:nth-last-child(1)::after {
                                    content: '';
                                }
                            }
                        }
                        .house-mls-info {
                            width: 100%;
                            display: flex;
                            .mls-info {
                                width: 80%;
                                font-size: 12px;
                                color: #282828;
                                line-height: 14px;
                                margin-top: 10px;
                                display: block;
                            }
                            .house-mls-info-logo {
                                width: 20%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                img {
                                    max-height: 40%;
                                    max-width: 100%;
                                }
                            }
                        }

                        &:hover {
                            .addr {
                                @include color-theme();
                            }
                        }
                    }
                }
                &.school {
                    .item {
                        height: 70px;
                        padding: 13px 10px 0 30px;
                        cursor: pointer;
                        .score {
                            float: left;
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                            line-height: 50px;
                            font-size: 24px;
                            font-family: var(--font-bold);
                            text-align: center;
                            color: #ffffff;
                            margin-right: 20px;
                            &.high {
                                background-color: #07d35b;
                            }

                            &.middle {
                                background-color: #007aff;
                            }

                            &.low {
                                background-color: #98aabc;
                            }
                        }
                        .school-name {
                            font-family: var(--font-medium);
                            font-size: 16px;
                            color: #424242;
                            @include ellipsis();
                        }
                        .school-desc {
                            font-size: 16px;
                            color: #a0a0a0;
                        }
                    }
                }
                &.business {
                    .group {
                        color: #282828;
                        &:before {
                            border-bottom: 1px solid var(--color-border);
                        }
                        &:hover {
                            background: #f4f6fb;

                            @include color-theme();
                        }
                    }
                    .item {
                        height: 70px;
                        padding: 13px 10px 0 30px;
                        cursor: pointer;
                        .name {
                            font-family: var(--font-medium);
                            font-size: 16px;
                            color: #282828;
                            @include ellipsis();
                        }
                        .detail {
                            font-size: 14px;
                            color: #a0a0a0;
                            @include ellipsis();
                            .line {
                                margin: 0 10px;
                            }
                            .tel {
                                text-decoration: underline;
                                &:hover {
                                    @include color-theme();
                                }
                            }
                        }
                    }
                }
            }
        }
        .detail-header {
            @include color-theme();
            height: 60px;
            line-height: 60px;
            font-family: var(--font-bold);
            font-size: 16px;
            border-bottom: 1px solid #e6e6e6;
            overflow: hidden;
            .to-back {
                display: inline-block;
                cursor: pointer;
            }
            .icon-prev {
                width: 24px;
                height: 28px;
                line-height: 24px;
                margin: 8px 2px 8px 20px;
                font-weight: bold;
                display: inline-block;
                vertical-align: middle;
                cursor: pointer;
                position: relative;
                &:before {
                    position: absolute;
                    width: 24px;
                    text-align: center;
                }
            }
        }
        .detail-body {
            position: absolute;
            top: 60px;
            bottom: 0;
            width: 100%;
            overflow: hidden;
            .school {
                .name {
                    margin: 16px 30px;
                    font-family: var(--font-bold);
                    font-size: 20px;
                    line-height: 1.2;
                }
                .table {
                    margin-bottom: 10px;
                    padding: 5px 20px;
                    font-size: 16px;
                    font-family: var(--font-normal);
                    .item {
                        display: flex;
                        padding: 0 0 16px 10px;
                        cursor: default;
                        .label {
                            flex-shrink: 0;
                            width: 100px;
                            color: #a0a0a0;
                        }
                        .value {
                            flex-grow: 1;
                            color: #282828;
                        }
                    }
                }
            }
        }
        .more-panel {
            padding-bottom: 50px;
            .more {
                position: absolute;
                width: 100%;
                font-size: 16px;
                height: 50px;
                line-height: 50px;
                background: #fff;
                bottom: 0;
                text-align: center;

                a {
                    @include color-theme();
                    text-decoration: underline;
                }
            }
        }
        &.show-business {
            .tab-header {
                .active.item.business {
                    display: block;
                }
            }
        }
        &.collapsed {
            min-width: 0;
        }
    }
    @include media-600 {
        .map-tab-nbr {
            background-color: #fff;
            width: 100%;
            min-width: auto;
            height: initial;
            user-select: none;
            position: relative;
            .tab-collapse {
                right: auto;
                left: 0;
                top: -40px;
                line-height: 40px;
                width: 100px;
                display: flex;
                justify-content: space-around;
                border: none;
                padding: 0;
                .iconfont {
                    margin: 0 8px;
                    &.icon-show {
                        display: none;
                    }
                    &.icon-house-fill {
                        padding: 0;
                    }
                    &.icon-school3 {
                        text-indent: 0;
                    }
                }
            }
            .tab-header {
                border-bottom-style: none;
                height: 0;
                .item {
                    max-width: 50%;
                    padding: 0 20px;
                }
            }
            .tab-body {
                position: relative;
                left: initial;
                top: initial;
                bottom: initial;
                border: none;
                .tab-content {
                    .group {
                        margin-left: 15px;
                        margin-right: 15px;
                        .icon-arrow-down {
                            right: 0;
                        }
                    }
                    .item {
                        + .item {
                            &:before {
                                left: 0;
                                right: 0;
                            }
                        }
                    }
                    &.house .item,
                    &.school .item,
                    &.business .item {
                        padding-left: 20px;
                    }
                }
            }
            .detail-header .icon-prev {
                margin-left: 10px;
            }
            .detail-body {
                position: relative;
                top: initial;
                bottom: initial;
                border: none;
                .school {
                    .name {
                        margin: 16px 20px;
                    }
                    .table {
                        padding: 5px 10px;
                    }
                }
            }
            .more-panel {
                padding-bottom: 0;
                .more {
                    padding: 20px 0;
                    height: initial;
                    line-height: 1;
                    position: relative;
                    background: #fff;
                    &:before {
                        content: '';
                        position: absolute;
                        display: block;
                        top: 2px;
                        left: 0;
                        right: 0;
                        border-top: 1px solid var(--color-border);
                    }
                }
            }
            &:not(.collapsed) {
                .tab-header {
                    border-bottom-style: solid;
                    height: 60px;
                }
                .tab-body {
                    margin-bottom: 25px;
                }
            }
        }
    }
}
</style>
